export const BRAND_CONFIG = {
  297: {
    apiKey: process.env.VUE_APP_API_KEY || "",
    apiSecret: process.env.VUE_APP_API_SECRET || "",
    name: "MYSTAYS",
    bookingUrl: "https://booking.iconia.co.jp",
  },
  1585: {
    apiKey: process.env.VUE_APP_SEAGAIA_API_KEY,
    apiSecret: process.env.VUE_APP_SEAGAIA_API_SECRET,
    name: "SEAGAIA",
    bookingUrl: "https://booking.seagaia.co.jp",
  },
};
